import * as MyItemService from '@/components/lists/MyItemListService'
import { useRouter } from "vue-router"

export const getIcon = (item: MyItemService.Item, iconLeft: boolean) : string => {
    const router = useRouter();
    const routeName = router.currentRoute.value.name;
    let suffix = ''
    if (isActive(item) || (item.routeMatch && routeName?.toString().match(item.routeMatch))) {
        suffix += "_active"
    }

    return (iconLeft ? item.iconLeft : item.iconRight) + suffix
}

export const isActive = (item: MyItemService.Item): boolean|undefined => {
    if (item.active === undefined) {
        return undefined
    }
    
    return item.active
}